import React from "react";
import Layout from "../../layouts/landing";
import Hero from "../../components/templates/landing/CashFast/Hero";
import RealLife from "../../components/templates/landing/CashFast/RealLife";
import Stories from "../../components/templates/landing/CashFast/Stories";
import ClosingCta from "../../components/templates/landing/CashFast/ClosingCta";
import HowItWorks from "../../components/templates/landing/InstantCash/HowItWorks";
import PageFooter from "../../components/templates/landing/InstantCash/PageFooter";
import Disclaimer from "../../components/templates/landing/InstantCash/Disclaimer";
import { tribesConfig } from "../../app.config";
import { Theme } from "./styles-cash-fast";

import heroRelief from "../../assets/landing/v2-hero-relief.jpg";
import story1 from "../../assets/landing/v2-story-1.jpg";
import story2 from "../../assets/landing/v2-story-2.jpg";
import story3 from "../../assets/landing/v2-story-3.jpg";

const COMPANY = "Patria Lending";
/* The reference links "click here" at the tribe's own about page rather than a
 * route in this app, so it is built from the tenant's configured website.
 *
 * Read from the env var rather than tribesConfig.website: that one is
 * String(process.env...), and String(undefined) is the string "undefined", so an
 * unset var produced the truthy "https://undefined/about" and Disclaimer
 * rendered the sentence with a dead link instead of dropping it. process.env is
 * undefined or "" when absent, which is falsy. */
const tribeWebsite = process.env.REACT_APP_TRIBE_WEBSITE?.trim();
const tribeInfoUrl = tribeWebsite
  ? `https://${tribeWebsite.replace(/^https?:\/\//, "")}/about`
  : undefined;

const metrics = [
  { value: "$2,000", label: "Up to" },
  { value: "60s", label: "Approval" },
  { value: "0", label: "Hidden fees" },
];

const stories = [
  {
    quote:
      "The car broke down Friday. Money hit my account Saturday morning. That was it.",
    name: "Marcus D.",
    place: "Tulsa, OK",
    tag: "Auto repair",
    color: "var(--brand-red)",
    image: story1,
    alt: "A man smiling outside an auto repair shop",
  },
  {
    quote:
      "I was two days from my paycheck and the fridge died. Patria got me through.",
    name: "Elena R.",
    place: "Phoenix, AZ",
    tag: "Appliance",
    color: "var(--brand-green-deep)",
    image: story2,
    alt: "A woman smiling at her kitchen table",
  },
  {
    quote:
      "Simple form, no runaround, no lectures. I felt like a person, not a score.",
    name: "Aisha K.",
    place: "Atlanta, GA",
    tag: "Medical",
    color: "var(--brand-blue-deep)",
    image: story3,
    alt: "A healthcare worker smiling on a city street",
  },
];

const CashFast = () => {
  return (
    <Theme>
      <Layout
        showApplyCta
        ctaLabel="Apply"
        tagline="Safe. Fast. Secure."
        footer={<PageFooter companyName={COMPANY} tone="dark" />}
      >
        <Hero directMailUrl={process.env.REACT_APP_DIRECT_MAIL_URL} />
        <RealLife
          image={heroRelief}
          alt="A Patria customer on his porch at golden hour"
          kicker="Ray, 34 · Denver"
          quote={`"Had breathing room by dinner."`}
          badge="Approved in 42 seconds"
          metrics={metrics}
          eyebrow="For real life"
          heading={
            <>
              When the car doesn&apos;t start,{" "}
              <span className="accent">we do.</span>
            </>
          }
          copy="Millions of Americans don't have a safety net when life throws a curveball. Patria is built for those moments — a fast, honest option so you can get back to the day."
        />
        {/* v2 flips the process section: bone cards on white */}
        <HowItWorks background="#fff" cardBackground="var(--brand-bone)" />
        <Stories
          stories={stories}
          eyebrow="Real people, real moments"
          heading="We show up on the days that matter."
        />
        <ClosingCta />
        <Disclaimer
          companyName={COMPANY}
          tribe={`${tribesConfig.tribalLands} Tribe`}
          moreInfoUrl={tribeInfoUrl}
        />
      </Layout>
    </Theme>
  );
};

export default CashFast;
